export enum EnumTipoAvaliacaoQuestionarioUG {
    avaliacao = 1,
    replica = 2,
    avaliacaoFinal = 3
}